import styled from 'styled-components';

export const Container = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 480px;
  overflow: hidden;
  margin: 20px auto;
`;

export const Header = styled.div`
  background: #2c3e50;
  color: white;
  padding: 30px 20px;
  text-align: center;
`;

export const HeaderTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
  line-height: 1.4;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

export const FormContainer = styled.div`
  padding: 30px;
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #2c3e50;
  font-size: 14px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

export const EmailInput = styled.input`
  width: 30%;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #3498db;
    box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
  }

  &::placeholder {
    color: #999;
  }
`;

export const CheckboxGroup = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 25px;
`;

export const Checkbox = styled.input`
  margin-top: 3px;
  margin-right: 10px;
  flex-shrink: 0;
`;

export const CheckboxLabel = styled.label`
  font-size: 14px;
  color: #555;
  line-height: 1.5;
  font-weight: normal;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

export const PrivacyLink = styled.a`
  color: #3498db;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const SubscribeButton = styled.button`
  background: #3498db;
  color: white;
  border: none;
  padding: 15px;
  width: 100%;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;

  &:hover {
    background: #2980b9;
  }

  &:active {
    transform: translateY(1px);
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 0;
  border-top: 1px solid #eee;
  gap: 25px;

  @media (max-width: 500px) {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
`;

export const FooterLink = styled.a`
  color: #7f8c8d;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;

  &:hover {
    color: #3498db;
  }
`;

export const SuccessMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px;
  background: #f0f9ff;
  border-radius: 8px;
  margin-top: 20px;
  color: #2c3e50;
`;

export const SuccessIcon = styled.div`
  color: #2ecc71;
  font-size: 24px;
  margin-bottom: 10px;
  font-weight: bold;
`;

export const SuccessText = styled.p`
  margin: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

// Mobile responsive styles
export const MobileContainer = styled(Container)`
  @media (max-width: 500px) {
    border-radius: 10px;
    margin: 10px;
    max-width: calc(100% - 20px);
  }
`;

export const MobileHeader = styled(Header)`
  @media (max-width: 500px) {
    padding: 25px 15px;
  }
`;

export const MobileHeaderTitle = styled(HeaderTitle)`
  @media (max-width: 500px) {
    font-size: 20px;
  }
`;

export const MobileFormContainer = styled(FormContainer)`
  @media (max-width: 500px) {
    padding: 25px 20px;
  }
`;
